import _isArray from "lodash/isArray";
export function getOneUploadFile(files) {
    return _isArray(files) ? files[0] : files;
}
export function getUploadFiles(files) {
    return _isArray(files) ? files : [files];
}
